export const PLAYERSTATUS = {
    PLAYING: 'PLAYING',
    PAUSED: 'PAUSED',
    LOADING: 'PLAYER_LOADING',
    TEMP_PAUSE: 'TEMP PAUSE',
    REPEAT: 'REPEAT',
    CLOSED: 'CLOSED'
};

export const ROLES = {
    USER: 1,
    EMPLOYEE: 2,
    ADMIN: 3,
}